$(function() {

  ABTest(getUrlVars('v'));

  /**
   * Replace all SVG images with inline SVG
  */
  $('.feature .image[src*=".svg"]').each(function() {
    var $img = $(this);
    var imgID = $img.attr('id');
    var imgClass = $img.attr('class');
    var imgURL = $img.attr('src');

    $.get(
      imgURL,
      function(data) {
        // Get the SVG tag, ignore the rest
        var $svg = $(data).find('svg');

        // Add replaced image's ID to the new SVG
        if (typeof imgID !== 'undefined') {
          $svg = $svg.attr('id', imgID);
        }
        // Add replaced image's classes to the new SVG
        if (typeof imgClass !== 'undefined') {
          $svg = $svg.attr('class', imgClass + ' replaced-svg');
        }

        // Remove any invalid XML tags as per http://validator.w3.org
        $svg = $svg.removeAttr('xmlns:a');

        // Replace image with new SVG
        $img.replaceWith($svg);
      },
      'xml'
    );
  });



  // GDPR Rakuten
  $('body').on('click', '.wpcc-btn', function(e){
    window.__rmcp2 = [1,2,3,4,5,6,7,8,9,10];
  });

  function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  };

  function checkCookie() {
    var cookie = getCookie("wpcc");
    if (cookie != "") {
      window.__rmcp2 = [1,2,3,4,5,6,7,8,9,10];
    } else {
      // Do Nothing
    }
  };

  checkCookie();

  //End GDPR

  $(".mega-nav li:contains('COVID-19')").html(function(_, html) {
    return html.replace(/(COVID-19)/g, '<span class="fb-hide">$1&nbsp;</span>');
  });

  $(".site-footer h4:contains('COVID-19')").html(function(_, html) {
    return html.replace(/(COVID-19)/g, '<span class="fb-hide">$1&nbsp;</span>');
  });

  $(".footer-nav li:contains('COVID-19')").html(function(_, html) {
    return html.replace(/(COVID-19)/g, '<span class="fb-hide">$1&nbsp;</span>');
  });

  // Select thumb on hover
  // $('.product-single__thumbnail').on('mouseover', function() {
  //   if(!$(this).hasClass('active-thumb')) {
  //     $(this).click();
  //   }
  // });

  if($('.main-carousel.splide').length > 0) {
    var mainCarousel = new Splide( '.main-carousel', {
      type: 'fade',
      rewind: true,
      autoplay: true,
      interval: 7000,
    }).mount();
  }

  if($('.latest-order__items.splide').length > 0) {
    // console.log('do it');
    var latestOrderSlider = new Splide( '.latest-order__items', {
      type: 'slide',
      perMove: 1,
      fixedWidth: '150px',
      gap: '1em',
      omitEnd: true,
      pagination: false,
    }).mount();
  }

  setTimeout(function() {
    $('.product-slider.splide').each(function(i, el ) {
      var sliderID = el.getAttribute('id');
      var slider = new Splide( '#'+sliderID, {
        type: 'slide',
        perMove: 1,
        perPage: 4,
        omitEnd: true,
        pagination: false,
        breakpoints: {
          1200: {
            fixedWidth: '270px',
            perPage: false
          },
        },
      }).mount();

      if( $('.product-slider--tabs').length > 0 ) {
        $('.tabs__panel').on('TabPanel:activated', function() {
          var prodSlider = $(this).find('.product-slider--tabs');

          if(slider.root.id == prodSlider.attr('id') ) {
            setTimeout(function() {
              slider.refresh();
            }, 20);
          }
        });
      }
    });
  }, 1000);

  $('.product-data--collapsible .product-data__section-inner').each(function(i, el) {
    if(el.scrollHeight > 400) {
      $(el).parent().addClass('product-data__section--collapsible').addClass('product-data__section--collapsed');
    }
    // console.log(el.offsetHeight);
  });

  $('.product-data__learn-more').on('click', function(){
    $(this).parent().toggleClass('product-data__section--collapsed');
  });

  $('input[type="radio"]').on('change', function(e) {
    var el = e.target,
        elName = $(el).attr('name'),
        value = $(el).val(),
        $select = $('#'+ elName);

    $select.val(value).trigger('change');
  });

  var $inputs = $(":input:not([type=radio]):not([type=checkbox])");
  $inputs.on('input',function() {
    $('input[name="' + this.name + '"]').val($(this).val());
  });

  // Quantity Selector change price
  function quantitySelector(productForm) {
    let qty = $(productForm).find('.product-form__input--quantity').val();
    let $selectedVariation = $(productForm).find('[type=radio]:checked');
    let regularPrice = $selectedVariation.attr('data-regular-price');
    let salePrice = $selectedVariation.attr('data-sale-price');
    let $priceContainer = $('[data-price]');
    let $regularPriceField = $priceContainer.find('[data-regular-price]');
    let $salePriceField = $priceContainer.find('[data-sale-price]');
    let newRegularPrice = qty * regularPrice;
    let newSalePrice = qty * salePrice;

    // Create our number formatter.
    var formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    });

    if(!isNaN(newRegularPrice)) {
      $regularPriceField.each(function(i, el){
        $(el).text(formatter.format(newRegularPrice))
      });
    }

    if(!isNaN(newSalePrice)) {
      $salePriceField.each(function(i, el){
        $(el).text(formatter.format(newSalePrice))
      });
    }
  }

  $('.product-form').on('change', function(){
    quantitySelector(this);
  });

  $(document).ready( function(){
    quantitySelector($('.product-form')[0]);
  });


  // Mega Sub Collections
  // $('.mega-nav__collection-sub').each(function(i, el){
  //   if(i === 0) {
  //     $(this).show();
  //   }
  // });

  // $('.mega-nav__collection li').each(function(i, el){
  //   if(i === 0) {
  //     $(this).addClass('active');
  //   }
  // });

  $('.mega-nav__collection li').on('mouseover', function(){
    let collectionID = $(this).attr('id');
    const $parent = $(this).parents('.mega-nav__section');
    const $sub = $('[data-parent="'+collectionID+'"]');

    if(!$(this).hasClass('active')) {
      $('.mega-nav__collection li').removeClass('active');
      $('.mega-nav__collection-sub').hide();
      $('.mega-nav__subs').removeClass('active');
      $(this).addClass('active');
    }

    if(typeof collectionID !== "undefined") {
      $parent.next().addClass('active');

      $sub.fadeIn(200);
    } else {
      $('.mega-nav__subs').removeClass('active');
      $('.mega-nav__collection-sub').removeClass('active');
    }
  });

  $('.mega-nav__collection-sub--secondary li').on('mouseover', function(){
    let collectionID = $(this).attr('id');
    const $parent = $(this).parents('.mega-nav__section');
    const $tertiary = $parent.next();
    const $quaternary = $tertiary.next();
    const $sub = $('[data-parent="'+collectionID+'"]');

    if(!$(this).hasClass('active')) {
      $('.mega-nav__collection-sub--tertiary').hide();
      $('.mega-nav__collection-sub--quaternary').hide();
      $tertiary.removeClass('active');
      $quaternary.removeClass('active');
      $(this).addClass('active');
      $(this).siblings().removeClass('active');
    }

    if(typeof collectionID !== "undefined") {
      $tertiary.addClass('active');

      $sub.fadeIn(200);
    }
  });

  $('.mega-nav__collection-sub--tertiary li').on('mouseover', function(){
    let collectionID = $(this).attr('id');
    const $parent = $(this).parents('.mega-nav__section');
    const $quaternary= $parent.next();
    const $sub = $('[data-parent="'+collectionID+'"]');

    if(!$(this).hasClass('active')) {
      $('.mega-nav__collection-sub--quaternary').hide();
      $quaternary.removeClass('active');
      $(this).addClass('active');
      $(this).siblings().removeClass('active');
    }

    if(typeof collectionID !== "undefined") {
      $quaternary.addClass('active');

      $sub.fadeIn(200);
    }
  });

  $('.mega-nav__departments li').on('mouseover', function(){
    const featuredSKU = $(this).data('featured-sku');
    const $activeFeaturedProduct = $('.mega-nav__featured--item.active');
    const activeFeaturedSKU = $activeFeaturedProduct.data('product-sku');
    const $newFeaturedProduct = $('[data-product-sku="'+featuredSKU+'"]');

    // console.log($newFeaturedProduct);

    if(typeof featuredSKU !== "undefined" && activeFeaturedSKU != featuredSKU && $newFeaturedProduct.length > 0) {

      $activeFeaturedProduct.hide().removeClass('active');
      $newFeaturedProduct.fadeIn(200).addClass('active');
    } else if (typeof featuredSKU == "undefined" || $newFeaturedProduct.length == 0) {
      const $parent = $('.mega-nav__collection-top.active');
      const parentFeaturedSKU = $parent.data('featured-sku');
      const $parentFeaturedProduct = $('[data-product-sku="'+parentFeaturedSKU+'"]');

      if(!$parentFeaturedProduct.hasClass('active')) {
        $activeFeaturedProduct.hide().removeClass('active');
        $parentFeaturedProduct.fadeIn(200).addClass('active');
      }
    }
  });

  // Mobile Menu
  let menu = $('#MobileNavContainer');
  if(menu.length > 0) {

    // Clone Departments Nav
    // let $megaDepartments = $('.mega-nav__section--departments').find('.mega-nav__collection-top').clone(true);
    // let $mobileDepartments = $('#mm-all-departments');
    // $mobileDepartments.after($megaDepartments);

    // // Clone Brands Nav
    // let $megaBrands = $('.mega-nav__brands').find('li').clone(true);
    // let $mobileBrands = $('#mm-brands');
    // $mobileBrands.after($megaBrands);

    menu.removeAttr('class');

    mmenu = new Mmenu(menu[0], {
      "navbar": {
        title: `
          <div class="logo">
            <a href="/">
              <img src="//cdn.shopify.com/s/files/1/0275/1905/7963/t/2/assets/logo-stacked.png?v=10570687547843636527" height="50">
            </a>
          </div>`
      },
      "extensions": [
        "position-front",
        "pagedim-black",
        "border-full"
      ]
    },{
      offCanvas: {
        // clone: true
      }
    });
  }

  // Mobile Filter Menu
  let mobileFilters = $('#MobileFilters');
  if(mobileFilters.length > 0) {
    mobileFilters = new Mmenu(mobileFilters[0], {
      "navbar": {
        title: `Filters`
      },
      "navbars": [
        {
            "position": "bottom",
            "content": [
              '<button class="btn btn--secondary-accent filter-reset" disabled>Reset Filters</button>',
              '<button class="btn filter-save">Apply Filters</button>',
            ]
        }
      ],
      "extensions": [
        "position-bottom",
        "position-front",
        "pagedim-black",
        "border-full"
      ]
    });

    $('.filter-save').on( 'click', function() {
      mobileFilters.API.close();
    });

  }

  // Mobile Sub Collection Menu
  let subCollections = $('#SubCollections');
  if(subCollections.length > 0) {
    subCollections = new Mmenu(subCollections[0], {
      "navbar": {
        title: `Sub Collections`
      },
      "extensions": [
        "position-bottom",
        "position-front",
        "pagedim-black",
        "border-full"
      ]
    });
  }

  $('.product-single__thumbnail').each(function(i, el) {
    $(el).on('click', function(e) {
      var $badge = $('.covid-icon__container');

      if(i === 0) {
        $badge.show();
      } else {
        $badge.hide();
      }
    })
  });


  // Back To Top
  var scrollToTop = $('.back-to-top');

  $(window).on('scroll load', function() {
    if ($(window).scrollTop() > 100) {
      scrollToTop.addClass('back-to-top--show');
    } else {
      scrollToTop.removeClass('back-to-top--show');
    }
  });

  scrollToTop.on('click', function(e) {
    e.preventDefault();
    $('html, body').animate({scrollTop:0}, '300');
  });

  // Accordions
  // $acc_panel = $('.accordions__panel');
  $accs = $('.accordions');
  $accs.on('click', '.accordions__title', function(e){
    $title = $(this);
    $parent = $title.parent();
    $content = $title.next();

    if(!$parent.hasClass('active')) {
      $parent.addClass('active');
        $content.slideDown(200, function(){
      });
    } else {
      $parent.removeClass('active');
        $content.slideUp(200, function(){
      });
    }
  });

  /**
   * FAQ Search and Filter
   */
  const faqSearch = $('#faq-search');
  if(faqSearch.length > 0) {

    // Filter searched FAQ's
    var options = {
      searchClass: 'search',
      listClass: 'accordions__group',
      valueNames: [
        'accordions__title',
        // 'accordions__content',
      ]
    };
    
    var instance = [];
    
    $('.accordions').each(function(i,e){
      instance.push( new List(e, options) );
    });
    
    $(".search").on('keyup', function(){
      $.each(instance, (i,e) => {
        e.search($(this).val());
      })
    });

    // Highlight Search Results
    var markInstance = new Mark(document.querySelector(".accordions"));
    var keywordInput = document.querySelector("input[name='search']");

    keywordInput.addEventListener("input", function(){
        var keyword = keywordInput.value;

        markInstance.unmark({
            done: function(){
                markInstance.mark(keyword, {
                    exclude: [
                        'h2'
                    ]
                });
            }
        });
    });
  }
});

$(function(){
  // bind change event to select
  $('#contentNav').on('change', function () {
      var url = $(this).val(); // get selected value
      if (url) { // require a URL
          window.location = url; // redirect
      }
      return false;
  });
});

function getUrlVars(param) {
  const urlParams = new URLSearchParams(window.location.search);

  if(param) {
    const myParam = urlParams.get(param);
    return myParam;
  }

  const params = Object.fromEntries(urlParams.entries());
  return params;
}

function addCss(fileName) {
  var link = $("<link />",{
    rel: "stylesheet",
    type: "text/css",
    href: fileName
  })
  
  $('head').append(link);
}

// AB TESTING //
function ABTest(version) {

  if(version == 'brick' || version == 'navy') {
    var assetURL = $('#site-logo').attr('src');
    var lastIndex = assetURL.lastIndexOf("/");
    var timestamp = new Date().getTime();
    assetURL = assetURL.substring(0, lastIndex);
    addCss(`${assetURL}/${version}.scss.css?t=${timestamp}`);
    
    var siteURL =  top.location.host.toString();
    setTimeout(function(){
      var $internalLinks = $(`a[href*="${siteURL}"], a[href^="/"], a[href^="./"], a[href^="../"]`);
      $internalLinks.each( function( index, element ){
        var url = $( element ).prop( 'href' );
      
        if ( url.indexOf( '?' ) == -1 ) {
          url += `?v=${version}`;
        } else {
          url += `&v=${version}`;
        }
      
        $( element ).prop( 'href', url );
      });
    }, 500);  
  }
}

// Filtering
const $filterCollectionTemplate = $('#shopify-section-collection-template');;
if($filterCollectionTemplate.length > 0) {
  var itemSelector = ".grid__item--collection-template";
  var $checkboxes = $('.filter-input');
  var $container = $('.collection-grid').isotope({ itemSelector: itemSelector });
  var $filterReset = $('.filter-reset');

  //Ascending order
  var responsiveIsotope = [ [750, 15]  ];
  var itemsPerPageDefault = 15;
  var itemsPerPage = defineItemsPerPage();
  var currentNumberPages = 1;
  var currentPage = 1;
  var currentFilter = '*';
  var filterAttribute = 'data-filter';
  var filterValue = "";
  var pageAttribute = 'data-page';
  var pagerClass = 'isotope-pager';

  // update items based on current filters
  function changeFilter(selector) {
    $container.isotope({ filter: selector });
  }

  //grab all checked filters and goto page on fresh isotope output
  function goToPage(n) {
      currentPage = n;
      var selector = itemSelector;
      var exclusives = [];

      // for each box checked, add its value and push to array
      $checkboxes.each(function (i, elem) {
          if (elem.checked) {
              selector += ( currentFilter != '*' ) ? '.'+elem.value : '';
              exclusives.push(selector);
          }
      });
      // smash all values back together for 'and' filtering
      filterValue = exclusives.length ? exclusives.join('') : '*';

      // add page number to the string of filters
      var wordPage = currentPage.toString();
      filterValue += ('.'+wordPage);

      
      changeFilter(filterValue);
      CreatePagers();
      // console.log('hello');
  }

  // determine page breaks based on window width and preset values
  function defineItemsPerPage() {
      var pages = itemsPerPageDefault;

      for( var i = 0; i < responsiveIsotope.length; i++ ) {
          if( $(window).width() <= responsiveIsotope[i][0] ) {
              pages = responsiveIsotope[i][1];
              break;
          }
      }
      return pages;
  }

  function setPagination() {

      var SettingsPagesOnItems = function(){
          var itemsLength = $container.children(itemSelector).length;
          var pages = Math.ceil(itemsLength / itemsPerPage);
          var item = 1;
          var page = 1;
          var selector = itemSelector;
          var exclusives = [];
          // for each box checked, add its value and push to array
          $checkboxes.each(function (i, elem) {
              var $labels = $('label[for='+$(elem).attr('id')+']');

              if (elem.checked) {
                  selector += ( currentFilter != '*' ) ? '.'+elem.value : '';
                  exclusives.push(selector);
                  $labels.addClass('active');
              } else {
                  $labels.removeClass('active');
              }
          });
          // smash all values back together for 'and' filtering
          filterValue = exclusives.length ? exclusives.join('') : '*';
          // find each child element with current filter values
          $container.children(filterValue).each(function(){
              // increment page if a new one is needed
              if( item > itemsPerPage ) {
                  page++;
                  item = 1;
              }
              // add page number to element as a class
              wordPage = page.toString();

              var classes = $(this).attr('class').split(' ');
              var lastClass = classes[classes.length-1];
              // last class shorter than 4 will be a page number, if so, grab and replace
              if(lastClass.length < 4){
                  $(this).removeClass();
                  classes.pop();
                  classes.push(wordPage);
                  classes = classes.join(' ');
                  $(this).addClass(classes);
              } else {
                  // if there was no page number, add it
                  $(this).addClass(wordPage);
              }
              item++;
          });
          currentNumberPages = page;

          if(exclusives.length > 0) {
            $filterReset.each(function(i, el) {
              el.disabled = false;
            });
          } else {
            $filterReset.each(function(i, el) {
              el.disabled = true;
            });
          }
      }();

      
  }

  // create page number navigation
  function CreatePagers() {

      var $isotopePager = ( $('.'+pagerClass).length == 0 ) ? $('<ul class="'+pagerClass+' list--inline pagination"></ul>') : $('.'+pagerClass);

      $isotopePager.html('');
      if(currentNumberPages > 1){
        $isotopePager.html(`<li class="pagination__text">Page ${currentPage} of ${currentNumberPages}</li>`);

        $prev = $('<li aria-hidden="true"><button class="btn btn--tertiary btn--narrow" disabled=""><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-arrow-left" viewBox="0 0 20 8"><path d="M4.814 7.555C3.95 6.61 3.2 5.893 2.568 5.4 1.937 4.91 1.341 4.544.781 4.303v-.44a9.933 9.933 0 0 0 1.875-1.196c.606-.485 1.328-1.196 2.168-2.134h.752c-.612 1.309-1.253 2.315-1.924 3.018H19.23v.986H3.652c.495.632.84 1.1 1.036 1.406.195.306.485.843.869 1.612h-.743z" fill="#000" fill-rule="evenodd"></path></svg><span class="icon__fallback-text">Previous page</span></button></li>');
        if(currentPage > 1) {
          const $prevBtn = $prev.find('button');
          $prev.attr('aria-hidden', false);
          $prevBtn.attr('disabled', false);

          $prevBtn.click(function() {
            goToPage(currentPage - 1);

            $([document.documentElement, document.body]).animate({
              scrollTop: $container.offset().top - 150
            }, 1000);
          });
        }

        $next = $('<li aria-hidden="true"><button class="btn btn--tertiary btn--narrow" disabled=""><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-arrow-right" viewBox="0 0 20 8"><path d="M15.186.445c.865.944 1.614 1.662 2.246 2.154.631.491 1.227.857 1.787 1.098v.44a9.933 9.933 0 0 0-1.875 1.196c-.606.485-1.328 1.196-2.168 2.134h-.752c.612-1.309 1.253-2.315 1.924-3.018H.77v-.986h15.577c-.495-.632-.84-1.1-1.035-1.406-.196-.306-.486-.843-.87-1.612h.743z" fill="#000" fill-rule="evenodd"></path></svg><span class="icon__fallback-text">Next page</span></button></li>');
        if(currentPage < currentNumberPages) {
          const $nextBtn = $next.find('button');
          $next.attr('aria-hidden', false);
          $nextBtn.attr('disabled', false);

          $nextBtn.click(function() {
            goToPage(currentPage + 1);

            $([document.documentElement, document.body]).animate({
              scrollTop: $container.offset().top - 150
            }, 1000);
          });
        }

        $prev.prependTo($isotopePager);
        $next.appendTo($isotopePager);

        // for( var i = 0; i < currentNumberPages; i++ ) {
        //     var pageNumber = i+1;
        //     var $pager = $('<a href="javascript:void(0);" class="pager" '+pageAttribute+'="'+(pageNumber)+'"></a>');
        //         $pager.html(pageNumber);

        //         if(currentPage === pageNumber) {
        //           $pager.addClass('pager--current');
        //         }

        //         $pager.click(function(){
        //             var page = $(this).eq(0).attr(pageAttribute);
        //             $('.pager--current').removeClass('pager--current');
        //             $(this).addClass('pager--current');
        //             goToPage(page);

        //             $([document.documentElement, document.body]).animate({
        //               scrollTop: $container.offset().top - 150
        //             }, 1000);
        //         });
        //     $pager.appendTo($isotopePager);
        // }
      }
      $container.after($isotopePager);
  };

  // remove checks from all boxes and refilter
  function clearAll(){
      $checkboxes.each(function (i, elem) {
          if (elem.checked) {
              elem.checked = null;
          }
      });
      currentFilter = '*';
      setPagination();
      goToPage(1);

      $([document.documentElement, document.body]).animate({
        scrollTop: $container.offset().top - 150
      }, 1000);
  }

  setPagination();
  goToPage(1);

  //event handlers
  $checkboxes.change(function(){
      var filter = $(this).attr(filterAttribute);

      if($(this).hasClass('filter-input--radio') && $(this).is(':checked')) {
        let name = $(this).attr('name');
        $('[name='+name+']').not(this).prop('checked', false);
      }

      currentFilter = filter;
      setPagination();
      goToPage(1);

      $([document.documentElement, document.body]).animate({
        scrollTop: $container.offset().top - 150
      }, 1000);
    });

  $filterReset.click(function(){clearAll()});

  $(window).resize(function(){
      itemsPerPage = defineItemsPerPage();
      setPagination();
      goToPage(1);
  });         
}


// FAQ's
/** Structure
  <h4>Title</h4>
  <p>Content...</p>
  <p>Content...</p>

  <h4>Title</h4>
  <p>Content...</p>
*/
var $faqContainer = $('#faqs');

if($faqContainer.length > 0) {
  $faqTitles = $faqContainer.find('h4');
  
  $faqTitles.each( function(i, el) {
    var $faqPanel = $('<div class="accordions__panel"></div>');
    var $faqTitle = $(el);
    var $faqContent = $('<div class="accordions__content"></div>');
    var faqSiblings = getNextUntil(el, 'h4');

    $faqTitle.addClass('accordions__title').wrap($faqPanel);

    $(faqSiblings).each(function(i, sib) {
      $faqContent.append(sib);
    });

    $faqTitle.after($faqContent);

  });
}

function getNextUntil(elem, selector) {

	// Setup siblings array and get next sibling
	var siblings = [];
	var next = elem.nextElementSibling;

	// Loop through all siblings
	while (next) {

		// If the matching item is found, quit
		if (selector && next.matches(selector)) break;

		// Otherwise, push to array
		siblings.push(next);

		// Get the next sibling
		next = next.nextElementSibling

	}

	return siblings;

};

// function getNextUntil(elem, selector) {

// 	// Setup siblings array and get next sibling
// 	var siblings = [];
// 	var next = elem.nextElementSibling;

// 	// Loop through all siblings
// 	while (next) {

// 		// If the matching item is found, quit
// 		if (next.matches(selector)) break;

// 		// Otherwise, push to array
// 		siblings.push(next);

// 		// Get the next sibling
// 		next = next.nextElementSibling

// 	}

// 	return siblings;

// };